var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.row.bank_name)?_c('img',{attrs:{"src":_vm.BankLogo(_vm.row.bank_name),"width":"42","height":"32"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }